import { render, staticRenderFns } from "./ARolePermissionField.vue?vue&type=template&id=0e13daf8&"
import script from "./ARolePermissionField.vue?vue&type=script&lang=js&"
export * from "./ARolePermissionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports